import { useContext } from "react";
import { SetupContext } from "./context";

export const useSetupContextProvider = () => {
  const context = useContext(SetupContext);
  if (!context) {
    throw new Error("No SetupContext context was provided.");
  }
  return context;
};
